import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {RequestMethod} from '@angular/http';

import {Observable} from 'rxjs/Observable';

import {DictService} from '../core/ecv-http-services/services/dict.service';
import {AuthService} from '../core/auth.service';
import {MockAuthService} from './mock-auth.service';
import {MockDictService} from './mock-dict.service';



@Injectable()
export class MockHttpInterceptor implements HttpInterceptor {
  constructor(private mockAuthService: MockAuthService,
              private mockDictService: MockDictService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    switch (request.method) {
      case RequestMethod[RequestMethod.Post].toUpperCase():
        return this.interceptPostMethod(request, next);
      case RequestMethod[RequestMethod.Get].toUpperCase():
        return this.interceptGetMethod(request, next);
      case RequestMethod[RequestMethod.Put].toUpperCase():
        return this.interceptPutMethod(request, next);
      case RequestMethod[RequestMethod.Delete].toUpperCase():
        return this.interceptDeleteMethod(request, next);
      default:
        return next.handle(request);
    }
  }

  private interceptPostMethod(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.endsWith(AuthService.loginUrl)) {
      return this.mockAuthService.logIn(request.body['username'], request.body['password']);
    }
    return next.handle(request);
  }

  private interceptGetMethod(request: HttpRequest<any>, next: HttpHandler) {
    if (request.url.endsWith(DictService.getSkillsPath)) {
      return this.mockDictService.getSkills();
    }
    return next.handle(request);
  }

  private interceptPutMethod(request: HttpRequest<any>, next: HttpHandler) {
    return next.handle(request);
  }

  private interceptDeleteMethod(request: HttpRequest<any>, next: HttpHandler) {
    return next.handle(request);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/mock/mock-http.interceptor.ts